import $ from 'jquery'; // eslint-disable-line import/no-extraneous-dependencies
import bootstrapSite from '../app/bootstrapSite';

bootstrapSite();

document.querySelector('.open-corporated-gift-card-slider').addEventListener('click', () => {
    import(/* webpackChunkName: "ShopSlider" */ '../components/ShopSlider').then((module) => {
        module.default()
    });
})